// Short-lived, public GET-only cache shared with the early HTML bootstrap.
const base = process.env.REACT_APP_BACKEND_URL;
const cache = () => (window.__LB_PUBLIC_REQUESTS__ ||= new Map());
const urlFor = path => `${base}/api${path}`;
export function peekPublicJSON(path) {
  const entry = cache().get(urlFor(path));
  return entry && Date.now() - entry.started < 30000 ? entry.data : undefined;
}
export function publicJSON(path) {
  const url = urlFor(path);
  const entries = cache();
  const found = entries.get(url);
  if (found && Date.now() - found.started < 30000) return found.promise;
  if (entries.size >= 100) entries.delete(entries.keys().next().value);
  const entry = { started: Date.now() };
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 20000);
  entry.promise = fetch(url, { credentials: 'omit', signal: controller.signal }).then(response => {
    if (!response.ok) throw Object.assign(new Error(`HTTP ${response.status}`), { status: response.status });
    return response.json();
  }).then(data => { entry.data = data; return data; }).catch(error => {
    if (entries.get(url) === entry) entries.delete(url);
    throw error;
  }).finally(() => clearTimeout(timer));
  entries.set(url, entry);
  return entry.promise;
}

export const isCatalogueNotFound = error => error?.status === 404 || error?.status === 410;